import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
    actions: {
        async getPlatformBasesData(context) {
            const response = await Vue.axios.get(`${URL_API}platformbase`);
            let data = response["data"];
            context.commit("updatePlatformBasesData", data);
        },
        async createPlatformBaseData(context, name) {
            const config = {};
            const body = {
                name: name
            };
            await Vue.axios.post(`${URL_API}platformbase/store`, body, config);
            context.dispatch("getPlatformBasesData");
        },
        async pushPlatformBaseData(context, { id, name }) {
            const config = {};
            const body = {
                id: id,
                name: name
            };
            await Vue.axios.post(`${URL_API}platformbase/update`, body, config);
            context.dispatch("getPlatformBasesData");
        },
        async destroyPlatformBaseData(context, id) {
            const config = {};
            const body = {
                id: id
            };
            await Vue.axios.post(`${URL_API}platformbase/destroy`, body, config);
            context.dispatch("getPlatformBasesData");
        }
    },
    mutations: {
        updatePlatformBasesData(state, platformBasesData) {
            state.platformBasesData = platformBasesData;
        }
    },
    state: {
        platformBasesData: []
    },
    getters: {
        allPlatformBasesData(state) {
            return state.platformBasesData;
        }
    }
};